import { TypographyV2 as Typography } from '@which/seatbelt';
import styles from './ToolHeading.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export const ToolHeading = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(Typography, {
    className: styles.toolHeading,
    tag: "h2",
    textStyle: "sb-text-heading-medium",
    ...rest,
    children: children
  });
};